import * as Actions from '../actions/organisationparticipantsummaryreport.actions';
import * as Constants from '../actions/organisationparticipantsummaryreport.constants';
import { OrganisationParticipantSummaryReportState } from '../types/organisationparticipantsummaryreport-state';
import { OrganisationParticipantSummaryItem } from '../types/organisationparticipantsummary-item';

const defaultState: Partial<OrganisationParticipantSummaryReportState> = {
  loading: false,
  data: [],
  selectedOrganisationId: undefined,
  organisations: []
};

export function reducer(
  state: Partial<OrganisationParticipantSummaryReportState> = defaultState,
  action: Actions.All
): Partial<OrganisationParticipantSummaryReportState> {

  switch (action.type) {

    case Constants.INITIALIZE:
    case Constants.DESTROY: {
      return { ...defaultState };
    }
    case Constants.LOAD_ORGANISATIONS: {
      return { ...state, loading: true };
    }
    case Constants.LOAD_ORGANISATIONS_DONE: {
      const { organisations } = action as Actions.LoadOrganisationsDoneAction;
      if (!state.selectedOrganisationId && organisations.length > 0) {
        return { ...state, organisations, selectedOrganisationId: organisations[0].id, loading: false };
      }
      return { ...state, organisations, loading: false };
    }
    case Constants.UPDATE_SELECTED_ORGANISATION_ID: {
      const { id } = action as Actions.UpdateSelectedOrganisationIdAction;
      return { ...state, selectedOrganisationId: id, loadingReport: true };
    }
    case Constants.REPORT_LOADED: {
      const { data } = action as Actions.ReportLoadedAction;
      return {
        ...state, loadingReport: false,
        data: data.map<OrganisationParticipantSummaryItem>((item) => {
          return {
            id: item.id,
            coordinator: item.coordinator_first + (item.coordinator_last ? ' ' + item.coordinator_last : ''),
            is_admin: (
              item.coordinator_role === 'System Admin' || item.coordinator_role === 'Organisation Admin'
            ) ? 'Yes' : 'No',
            participant_first: item.participant_first,
            participant_last: item.participant_last,
            ndis_number: item.ndis_number,
            created: item.created,
            updated: item.updated
          };
        })
      };
    }
    default:
      return state;
  }
}